
const errorCode = {
    200: '成功',
}
export default errorCode;